import apiClient, { unwrap } from './client'
import type { MailboxDetail, MailboxItem } from './types'

export interface MailboxQuery {
  email?: string
  domain?: string
  q?: string
  page?: number
  page_size?: number
}

export interface MailboxListResult {
  items: MailboxItem[]
  total: number
  page: number
  page_size: number
}

export const mailboxApi = {
  list(params: MailboxQuery) {
    return unwrap<MailboxListResult>(apiClient.get('/mailbox', { params }))
  },
  get(id: number) {
    return unwrap<MailboxDetail>(apiClient.get(`/mailbox/${id}`))
  },
  remove(ids: number[]) {
    return unwrap<{ deleted: number }>(apiClient.post('/mailbox/delete', { ids }))
  },
}